import { ClientType } from '@common/model/client/clientType';
import { AddIcon, SearchActiveIcon, SearchIcon, SigninIcon } from '@cp/ds/src/icons/mobileMenu';
import { ClientWebPage } from '@common/model/meta/clientWebPage';
import { clientTypeToSuitableCatalogItemType } from '@common/utils/catalogType';
import React from 'react';
import { CatalogItemType } from '@common/model/catalog/item/type';
import { CareerId } from '@common/const/catalog/career';
import { MenuItemWithTimedHints } from '../ui/menuItemWithTimedHints';
import { withFavoritesIcon } from '../ui/favoritesIcon';
import { MenuItemProps } from './item.interface';
import { ItemsCreatorProps, ItemsCreatorReturn } from './types';

export const createGuestItems = ({
  generateAppPath,
  routeParams,
  isLoadingNavigate,
  navigateToCatalog,
  onLogin,
  onSpecialistRegistration,
  onEmployerPreFilterRegistration,
  menuContainerRef,
}: ItemsCreatorProps): ItemsCreatorReturn => {
  const { pageId: currentPageId, pageProps } = routeParams;

  const items: MenuItemProps[] = [];
  const isCatalog = 'careerId' in pageProps && 'catalogType' in pageProps;
  const isFavarites = currentPageId === ClientWebPage.Favorites;

  if (isLoadingNavigate || (!isCatalog && !isFavarites)) {
    return { items, isLoading: isLoadingNavigate };
  }

  const isSearchActive = false;
  const careerId: CareerId = 'careerId' in pageProps ? (pageProps.careerId as CareerId) : CareerId.Nanny;
  const catalogType: CatalogItemType = 'catalogType' in pageProps ? (pageProps.catalogType as CatalogItemType) : CatalogItemType.Resume;
  const isSpecialist = catalogType === clientTypeToSuitableCatalogItemType(ClientType.Specialist);

  items.push({
    title: isSpecialist ? 'Работа' : 'Специалисты',
    icon: isSearchActive ? SearchActiveIcon : SearchIcon,
    onClick: navigateToCatalog,
    isActiveItem: isSearchActive,
  });

  items.push({
    title: 'Избранное',
    icon: withFavoritesIcon(isFavarites),
    href: generateAppPath({ page: ClientWebPage.Favorites }),
    isActiveItem: isFavarites,
  });

  items.push({
    title: isSpecialist ? 'Анкета' : 'Объявление',
    icon: AddIcon,
    onClick: () => {
      if (isSpecialist) {
        onSpecialistRegistration(careerId);
      } else {
        onEmployerPreFilterRegistration({ careerId });
      }
    },
    isActiveItem: false,
  });

  items.push({
    title: 'Войти',
    icon: SigninIcon,
    isActiveItem: false,
    onClick: onLogin,
    renderItem: ({ config }) =>
      React.createElement(MenuItemWithTimedHints, {
        config,
        menuContainerRef,
        hints: 'Регистрация',
        delayToShowInMs: 10000,
        tooltipProps: {
          bordered: true,
          slotProps: {
            popper: {
              disablePortal: true,
              sx: {
                paddingLeft: '1px',
              },
              modifiers: [
                {
                  name: 'offset',
                  options: {
                    offset: [0, 5],
                  },
                },
              ],
            },
          },
        },
      }),
  });

  return { items, isLoading: isLoadingNavigate };
};
